export default __webpack_public_path__ + "static/arindamLehri5-6aba9fbd66c1df8f2c961442f648b492.jpg";